<template>
  <div class="table">
    <div class="table-header">
      <div class="table-row">
        <div class="cell sort cell-large center" @click="setSorting('lotID')">
          Lot No
          <BaseIcon
            v-if="sortingOn == 'lotID'"
            :name="this.isAscending ? 'chevron-up' : 'chevron-down'"
            class="icon"
          />
        </div>
        <div class="cell sort cell-large center" @click="setSorting('ref')">
          REF
          <BaseIcon
            v-if="sortingOn == 'ref'"
            :name="this.isAscending ? 'chevron-up' : 'chevron-down'"
            class="icon"
          />
        </div>
        <div class="cell cell-medium center">Subparts</div>
        <div class="cell cell-big">Description</div>
        <LoadAmountList v-if="hasAmountDropdown" :totalItems="totalItems" @selectedAmount="selectedAmount" />
      </div>
    </div>
    <div class="table-content">
      <div
        class="table-row"
        v-bind:class="{'active-line-padding': selectedLot === lot}"
        v-for="(lot, index) in this.lots"
        :key="index"
        @click="selectRow(lot)"
      >
        <div class="cell cell-large center">{{lot.lotAssemblyID}}</div>
        <div class="cell cell-large center">{{lot.ref}}</div>
        <div class="cell cell-medium center">{{lot.subpartCount}}</div>
        <div class="cell cell-big">{{lot.description}}</div>
        <div class="cell">
          <i class="icon grey fa fa-ellipsis-h"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseIcon from "@/components/base/Icon";
import LoadAmountList from "@/components/base/LoadAmountList";

export default {
  components: {
    BaseIcon,
    LoadAmountList
  },
   
  props: {
    lots: {
      type: Array,
      required: true
    },
    hasAmountDropdown: {
      type: Boolean,
      default: true
    },
    totalItems: Number
  },
  mounted() {},
  data() {
    return {
      selectedLot: null,
      sortingOn: "lotID",
      isAscending: true
    };
  },
  methods: {
    selectedAmount(val) {
      this.$emit("selectedAmount", val);
    },
    selectRow(lot) {
      this.selectedLot = lot;
      this.$emit("selectedRow", lot);
    },
    setSorting(val) {
      if (this.sortingOn != val) {
        this.isAscending = true;
      } else {
        this.isAscending = !this.isAscending;
      }
      this.sortingOn = val;

      this.$emit("sorting", { on: this.sortingOn, asc: this.isAscending });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../style/base.scss";
@import "../style/components/tables.scss";
@import "@/style/components/active.scss";

.table-header {
  .table-row {
    .cell.sort {
      cursor: pointer;
    }
  }
}
</style>
